import { Button, TextArea, TextField } from "@flash-tecnologia/hros-web-ui-v2";
import { Box } from "src/components/core-components/atoms/Box/box";
import { Drawer } from "src/components/core-components/organisms/Drawer/drawer";
import { useCreateDepartmentDrawer } from "../../hooks/use-create-department-drawer";
import { Department } from "../../types";

interface CreateDepartmentDrawerProps {
  open: boolean;
  onClose: () => void;
  onSuccess: (department: Department) => void;
}

export const CreateDepartmentDrawer = ({
  onClose,
  onSuccess,
  open,
}: CreateDepartmentDrawerProps) => {
  const {
    description,
    isLoading,
    name,
    nameError,
    onDescriptionChange,
    onDrawerClose,
    onDrawerSubmit,
    onNameBlur,
    onNameChange,
  } = useCreateDepartmentDrawer({
    onClose,
    onSuccess,
  });

  return (
    <Drawer
      title="Novo departamento"
      subtitle={"Adicione as informações a seguir para criar um departamento"}
      open={open}
      onClose={onDrawerClose}
    >
      <Box flexDirection="column" gap="xs" $height="100%" $pb="xs">
        <Box flex={1} flexDirection="column" gap="xs2">
          <div>
            <TextField
              fullWidth
              onBlur={onNameBlur}
              onChange={(event) => onNameChange(event.target.value)}
              label={"Nome do departamento*"}
              error={!!nameError}
              helperText={nameError}
              value={name}
            />
          </div>
          <TextArea
            placeholder={"Adicione uma descrição"}
            onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
              onDescriptionChange(event.target.value)
            }
            height={100}
            maxLength={100}
            value={description}
          />
        </Box>
        <Box $width="100%" justifyContent="flex-end">
          <Button
            loading={isLoading}
            variant="primary"
            onClick={onDrawerSubmit}
          >
            Criar
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};
